import { AdminSettingsPage } from '@features/admin/components/AdminSettingsPage';
import { createFileRoute } from '@tanstack/react-router';

export const Route = createFileRoute('/_authenticated/_shell/admin/settings')({ component: AdminSettingsPage });
